import {
  areVariantIdsEqual,
  getLinks,
  getMappedWishlistVariants,
  getProductVariants,
  getVariantIds,
  getWcProductCards,
  preparePrice,
} from "./utils";

let initTimeout: number | null = null;

const init = async () => {
  if (!window.STOREFRONT_TOKEN) return;

  const wishlistProducts = getWcProductCards();
  if (!wishlistProducts.length) return;

  const mappedVariants = getMappedWishlistVariants(wishlistProducts);
  if (!mappedVariants) return;

  const productVariants = await getProductVariants();
  if (!productVariants.length) return;

  productVariants.forEach((item) => preparePrice(item, mappedVariants));
};

const scheduleInit = () => {
  if (initTimeout) return;

  initTimeout = window.setTimeout(() => {
    requestAnimationFrame(() => {
      init();
    });
    initTimeout = null;
  }, 50);
};

let lastVariantIds: string[] = [];

const initializeObserver = new MutationObserver(() => {
  requestAnimationFrame(() => {
    const container = document.querySelector(".WishlistClubContainer");
    if (!container) return;

    const links = getLinks();
    if (!links.length) return;

    const currentVariantIds = getVariantIds(links);
    if (areVariantIdsEqual(currentVariantIds, lastVariantIds)) return;

    lastVariantIds = currentVariantIds;
    scheduleInit();
  });
});

const removeObserver = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.type !== "childList") continue;

    for (const node of mutation.removedNodes) {
      if (!(node instanceof HTMLElement)) continue;

      if (node.classList.contains("wcProductList")) {
        scheduleInit();
        return;
      }
    }
  }
});

const start = () => {
  initializeObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  removeObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start, { once: true });
} else {
  start();
}
